var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 412.03 125.35",
    width: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    fillRule: "evenodd",
    points: "266.27 50.66 275.16 39.69 292.89 17.94 276.08 17.94 259.87 39.69 254.2 47.31 254.2 39.69 254.2 17.94 240.37 17.94 240.37 39.69 240.37 53.64 240.37 88.31 254.2 88.31 254.2 56.99 276.81 88.31 294.78 88.31 268.52 53.64 266.27 50.66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M149.1,17.94h-19.25V88.31h19.25c33.02,.12,34.42-30.34,34.49-34.73v-.43c0-.85,0-6.7-2.25-13.46-3.35-9.93-11.64-21.75-32.23-21.75Zm20.17,35.76c-.3,26.2-25.35,22.66-25.35,22.66V30s15.48-2.19,22.24,9.63c1.89,3.29,3.11,7.68,3.11,13.53v.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M388.05,24.37c-4.12-10.9-11.4-10.57-15.5,0-4.2,10.83-22.1,58.3-24.04,63.47l-19.49-28.9s5-.97,9.08-5.24c2.68-2.92,5-7.31,5-14.01v-.06s1.71-21.69-22.6-21.69h-19.31V88.31h13.83v-28.27l17.24,28.27h29.89l5.33-14.77h24.7l5.81,14.77h14.05s-19.86-53.04-23.98-63.93Zm-69.75,25.86h-3.29V29.21h3.29c11.88-.06,11.39,10.3,11.39,10.3v.18c0,1.34-.66,10.54-11.39,10.54Zm53.04,11.92l8.96-25.43,8.72,25.43h-17.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    fillRule: "evenodd",
    points: "192.18 39.69 192.12 53.64 192.12 88.31 228.43 88.31 228.43 76.37 206.01 76.37 206.01 57.36 227.7 57.36 227.7 53.64 227.7 45.36 206.01 45.36 206.01 39.69 206.01 30 228.49 30 228.49 18 192.18 18 192.18 39.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M79.11,33.41C64.93,24.96,28.09,3.7,23.57,1.11,19.05-1.47,15.18,.47,15.18,6.6v63.29l17.76-9.69V27.27l38.75,22.93L0,92.5v20.67s65.23-37.78,79.11-45.53c13.89-7.75,15.18-25.19,0-34.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M153.09,125.06h-2.29l-5.62-16.49-5.51,16.49h-2.29l-6.21-20.51h2.81l4.78,16.32,5.3-16.32h2.4l5.45,16.32,4.66-16.32h2.43l-5.92,20.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M169.35,116.27v8.79h-2.49v-8.79l-7.27-11.72h2.87l5.74,9.38,5.77-9.38h2.72l-7.35,11.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M194.37,123.06c-1.38,1.41-3.93,2.29-6.47,2.29-6.15,0-10.4-4.16-10.4-10.55,0-5.89,3.81-10.55,10.22-10.55,2.64,0,4.78,.73,6.24,1.99l-1.14,1.88c-1.35-1-2.93-1.52-5.07-1.52-4.45,0-7.62,3.34-7.62,8.2s3.25,8.2,8,8.2c1.96,0,3.84-.67,5.24-1.82l1,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M198.33,104.55h11.57v2.34h-9.08v6.62h8.2v2.34h-8.2v6.86h9.37v2.34h-11.86v-20.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M230.32,125.06l-12.8-16.11v16.11h-2.34v-20.51h1.99l12.8,16.17v-16.17h2.34v20.51h-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M245.44,116.27v8.79h-2.49v-8.79l-7.27-11.72h2.87l5.74,9.38,5.77-9.38h2.72l-7.35,11.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M286.57,125.06h-2.29l-5.62-16.49-5.51,16.49h-2.29l-6.21-20.51h2.81l4.78,16.32,5.3-16.32h2.4l5.45,16.32,4.66-16.32h2.43l-5.92,20.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M300.64,104.43h2.14l8.82,20.62h-2.67l-2.64-6.21h-9.35l-2.61,6.21h-2.52l8.82-20.62Zm-2.7,12.07h7.38l-3.69-8.76-3.69,8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M315.11,125.06v-20.51c1.14,0,4.92-.06,5.51-.06,5.6,0,7.29,2.78,7.29,6.09s-2.2,5.21-4.45,5.8l6.83,8.67h-3.05l-6.3-8.2h-3.34v8.2h-2.49Zm2.49-18.16v7.62h3.02c2.37,0,4.66-1.46,4.66-3.9,0-2.11-1.17-3.78-4.8-3.78-.64,0-1.9,.03-2.87,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M329.93,104.55h16.85v2.34h-7.18v18.16h-2.49v-18.16h-7.18v-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M358.03,104.26c5.95,0,10.46,4.31,10.46,10.55s-4.51,10.55-10.46,10.55-10.46-4.31-10.46-10.55,4.37-10.55,10.46-10.55Zm0,18.75c4.69,0,7.82-3.57,7.82-8.2s-3.43-8.2-7.82-8.2-7.82,3.43-7.82,8.2,3.43,8.2,7.82,8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M371.92,109.62c0-2.96,2.29-5.36,6.18-5.36,2.37,0,4.48,.85,5.65,2.14l-1.35,1.88c-1.08-1.08-2.37-1.67-4.16-1.67-2.29,0-3.69,1.2-3.69,3.02,0,5.07,10.02,3.16,10.02,10.17,0,3.37-2.96,5.57-6.68,5.57-2.52,0-5.45-1.14-6.47-3.08l1.44-1.7c1.2,1.58,3.34,2.43,5.07,2.43,2.14,0,4.01-1.11,4.01-3.19,0-5.01-10.02-3.4-10.02-10.2Zm5.04-6.09l-.67-1.41,5.71-3.05,.88,1.99-5.92,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M404.38,123.06c-1.38,1.41-3.93,2.29-6.47,2.29-6.15,0-10.4-4.16-10.4-10.55,0-5.89,3.81-10.55,10.22-10.55,2.64,0,4.78,.73,6.24,1.99l-1.14,1.88c-1.35-1-2.93-1.52-5.07-1.52-4.45,0-7.62,3.34-7.62,8.2s3.25,8.2,8,8.2c1.96,0,3.84-.67,5.24-1.82l1,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M408.92,104.55h2.49v20.51h-2.49v-20.51Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo-header.4cbcdce2f409df285226f1b66a58e810.svg";
export { ForwardRef as ReactComponent };